<template>
  <Breadcrumbs main="Administración" title="Soporte" />
  <div class="container-fluid">
    <div class="row project-cards">
      <TopMenu />
    </div>
  </div>
</template>
<script>
import TopMenu from "./components/TopMenu.vue";
export default {
  name: "support",
  components: {
    TopMenu,
  },
};
</script>
